import { useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import MessageTextContainer from "../MessageTextContainer";
import "./ToolCallResult.scss";

const ToolCallResult = ({ continuation }) => {
  const [expanded, setExpanded] = useState(false);

  if (!continuation) {
    return null;
  }

  const { toolName, toolInputJson, toolResultJson } = continuation;
  let toolInput = {};
  let toolResult = "";

  try {
    toolInput = toolInputJson ? JSON.parse(toolInputJson) : {};
  } catch (e) {
    console.error("Failed to parse tool input JSON", e);
  }

  try {
    const parsed = toolResultJson ? JSON.parse(toolResultJson) : [];
    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].text) {
      toolResult = parsed[0].text;
    } else {
      toolResult = toolResultJson || "";
    }
  } catch (e) {
    toolResult = toolResultJson || "";
  }

  return (
    <div
      className="tool_call_container"
      onClick={() => setExpanded(!expanded)}
    >
      <div className="tool_call_header">
        <div className="tool_call_name">
          <span className="tool_icon">🔧</span>
          <span className="tool_label">Tool Call:</span>
          <span className="tool_name_badge">{toolName}</span>
        </div>
        <div className="tool_call_toggle">
          {expanded ? <ChevronUpIcon size={18} /> : <ChevronDownIcon size={18} />}
        </div>
      </div>

      {expanded && (
        <div className="tool_call_body">
          {/* Tool Input */}
          {toolInput && Object.keys(toolInput).length > 0 && (
            <div className="tool_section">
              <div className="tool_section_title">Input Parameters</div>
              <div className="tool_params">
                {Object.entries(toolInput).map(([key, value]) => (
                  <div key={key} className="tool_param_row">
                    <div className="param_name">{key}:</div>
                    <div className="param_value">
                      {typeof value === "object"
                        ? JSON.stringify(value, null, 2)
                        : String(value)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tool Result */}
          {toolResult && (
            <div className="tool_section">
              <div className="tool_section_title">Result</div>
              <div className="tool_result_content">
                <MessageTextContainer>{toolResult}</MessageTextContainer>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolCallResult;
